import React from 'react';
import './ApplicationAreaSection.css'; 
import powerToolsImage from '../../assets/image 4.svg'; 

function ApplicationAreaSection() {
  return (
    <section id="area-aplicacao" className="application-area-section">
      <div className="container">
        {/* Subtítulo e Título */}
        <span className="subtitle">ÁREA DE APLICAÇÃO</span>
        <h2>Power Tools</h2>

        {/* Imagem Central */}
        <div className="image-wrapper">
          <img src={powerToolsImage} alt="Exposição Power Tools Bosch" className="power-tools-img" />
        </div>

        {/* Texto Descritivo Inferior */}
        <p className="description-text">
          A área PT (Power Tools) da Bosch é responsável pela produção, organização e distribuição
          de ferramentas elétricas utilizadas em diversos segmentos. Para garantir eficiência é
          preciso nesse processo, é essencial manter o controle sobre peças, displays e demandas
          de montagem. O DLOGIC surge como uma solução inovadora para automatizar
          cálculos, reduzir erros e facilitar a organização dentro desse fluxo produtivo.
        </p>
      </div>
    </section>
  );
}

export default ApplicationAreaSection;